import { render, staticRenderFns } from "./popup_lobby_video.vue?vue&type=template&id=059c1594&"
import script from "./popup_lobby_video.vue?vue&type=script&lang=js&"
export * from "./popup_lobby_video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports